// extracted by mini-css-extract-plugin
export default {"lotti":"ContactForm_lotti__sn+G+","contactform":"ContactForm_contactform__1wuxY"};